import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {EditWellnessPlanComponent} from "./edit-wellness-plan.component";

@NgModule({
  declarations: [EditWellnessPlanComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    DragDropModule
  ],
  exports: [EditWellnessPlanComponent],
})
export class EditWellnessPlanModule {}
